/**
 * Generate CRQCC data for a QRCode from an address
 *
 * @remarks CRQCC is a quick connect barcode format for the CR2700 reader
 *
 * @param address the address the reader will connect to, with no delimiters
 * @returns string value containing the generated CRQCC string
 */

export const crqcc = (address: string) =>
    `\x01Q\x1d\x02CMMOSCMBT\x03BTCMXCA${address}\x03\x04`
